import * as React from "react"
import {useTranslation} from "react-i18next"
import {capitalizeFirstLetter} from "../utilities/functions"
import {CourseWithSemesters} from "../backend/entity/grid/CourseWithSemesters";

interface CourseDetailsProps {
    record: CourseWithSemesters
}

function CourseDetails({record}: CourseDetailsProps) {
    const {t} = useTranslation()
    return (
        <>
            {record.course_semesters.map(item =>
                <div key={item.id}>
                    {capitalizeFirstLetter(
                            t('course.semester')) + ': ' + item.number + ', ' +
                        t('course.ects') + ': ' + item.ects + ', ' +
                        t('course.form_of_passing') + ': ' + item.form_of_passing.name + ', ' +
                        t('course.hours') + ': ' + item.hours}
                </div>
            )}
        </>
    )
}

export default CourseDetails